module.exports = __webpack_public_path__ + "static/assets/1864e76607e584900f76aa64a0c71baa.svg";